import { ImageIcon } from '@radix-ui/react-icons'
import { type Editor } from '@tiptap/react'
import { type VariantProps } from 'class-variance-authority'
import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogDescription,
	DialogTitle,
	DialogTrigger,
} from '#app/components/ui/dialog'
import { type toggleVariants } from '#app/components/ui/toggle'
import { ImageMediaBlock } from '../../extensions/image/components/image-media-block'
import { ToolbarButton } from '../toolbar-button'

interface ImageEditDialogProps extends VariantProps<typeof toggleVariants> {
	editor: Editor
}

const ImageEditDialog = ({ editor, size, variant }: ImageEditDialogProps) => {
	const [open, setOpen] = useState(false)

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<ToolbarButton
					isActive={editor.isActive('image')}
					tooltip="Image"
					aria-label="Image"
					size={size}
					variant={variant}
				>
					<ImageIcon className="size-5" />
				</ToolbarButton>
			</DialogTrigger>
			<DialogContent className="sm:max-w-lg">
				<DialogHeader>
					<DialogTitle>Insert Image</DialogTitle>
					<DialogDescription>
						Select from your media library or paste an image URL
					</DialogDescription>
				</DialogHeader>
				<ImageMediaBlock editor={editor} close={() => setOpen(false)} />
			</DialogContent>
		</Dialog>
	)
}

export { ImageEditDialog }
